import { VideoProject } from "@/services/bedrock";

export interface QaFlag {
  id: string;
  category: VideoProject.QaIssueCategory;
  comment: string;
  timestampMs?: number | null;
}

export function createQaFlagId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `qa-flag-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function buildQaIssues(flags: QaFlag[]): VideoProject.QaIssue[] {
  return flags.map(flag => {
    const comment = flag.comment.trim();
    return {
      category: flag.category,
      comment: comment || null,
      timestampMs: flag.timestampMs ?? null,
    };
  });
}

export function formatQaTimestamp(timestampMs?: number | null): string | null {
  if (timestampMs == null || Number.isNaN(timestampMs)) return null;
  const totalSeconds = Math.max(0, Math.floor(timestampMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export type LastFailResolution = "RESOLVED" | "UNRESOLVED";

export function qaIssueFromAuditIssue(issue: VideoProject.QaAuditIssue): VideoProject.QaIssue {
  return {
    category: issue.category,
    comment: issue.comment?.trim() || null,
    timestampMs: issue.timestampMs ?? null,
  };
}

export function unmarkedLastFailIssues(
  issues: VideoProject.QaAuditIssue[] | undefined,
  resolutions: Record<number, LastFailResolution | undefined>
): VideoProject.QaAuditIssue[] {
  return (issues || []).filter(issue => resolutions[issue.id] == null);
}

export function unresolvedLastFailIssues(
  issues: VideoProject.QaAuditIssue[] | undefined,
  resolutions: Record<number, LastFailResolution | undefined>
): VideoProject.QaIssue[] {
  return (issues || []).filter(issue => resolutions[issue.id] === "UNRESOLVED").map(qaIssueFromAuditIssue);
}
